// src/components/ResetPasswordPage/ResetPasswordPage.jsx

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const ResetPasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const { token } = queryString.parse(location.search);

  useEffect(() => {
    document.title = "GMA Portal • Reset Password";
    if (!token) setError("Invalid or missing token.");
  }, [token]);

  const validatePassword = (pwd) => /^.{10,}$/.test(pwd);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!token) {
      setError("Invalid or missing token.");
      return;
    }

    if (!validatePassword(password)) {
      setError("❌ Password must have at least 10 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("❌ Passwords do not match.");
      return;
    }

    try {
      const response = await fetch(
        "https://portal.gmacc.co.za/api/reset-password/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, new_password: password }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setSuccess("✅ Password reset successfully! Redirecting to login...");
        setTimeout(() => navigate("/"), 3000);
      } else {
        setError(data.error || "❌ Failed to reset password.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.authFrame}>
        <div className={styles.authMedia} aria-hidden="true"></div>

        {/* RIGHT PANEL */}
        <div className={styles.authPanel}>
          <div className={styles.formCard}>
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.logoImageForm}
            />

            {/* HEADING */}
            <h2 className={styles.heading}>RESET PASSWORD</h2>

            {/* ERROR / SUCCESS */}
            <div className={styles.row}>
              {error && <p className={styles.errorText}>{error}</p>}
              {success && <p className={styles.successText}>{success}</p>}
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit} className={styles.formCard}>
              {/* NEW PASSWORD */}
              <div className={styles.row}>
                <div className={styles.inputShell}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className={styles.input}
                  />

                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* CONFIRM PASSWORD */}
              <div className={styles.row}>
                <div className={styles.inputShell}>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    className={styles.input}
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                    </svg>
                  </button>
                </div>
              </div>

              <div className={styles.row}>
                {/* SUBMIT BUTTON */}
                <button type="submit" className={styles.buildingViewBtnLarge}>
                  Reset Password
                </button>
              </div>
            </form>
            <div className={styles.row}>
              {/* BACK LINK */}
              <div className={styles.logoutText} onClick={() => navigate("/")}>
                Back to Login
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
